import React, { Dispatch, memo, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, IconButton, styled, Typography } from "@mui/material";
import { MdArrowBack } from "@react-icons/all-files/md/MdArrowBack";
import { MdLocalPhone } from "@react-icons/all-files/md/MdLocalPhone";
import Header from "../header";
import { KYCConstants } from "../../../constants/application";
import Transition from "../transitionSlideUp";

const DialogBody = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => theme.spacing(2.5)};
`;

interface IHelp {
  /**
   * Help dialog visibility.
   */
  open: boolean;
  /**
   * Action event for Help dialog visibility.
   */
  close: Dispatch<SetStateAction<boolean>>;
}

function Help({ open, close }: IHelp) {
  const { t } = useTranslation();
  const onClose = () => {
    close((prev) => !prev);
  };
  return (
    <Dialog fullScreen open={open} TransitionComponent={Transition}>
      <Header showHelp={false} />
      <DialogBody>
        <IconButton id="back" onClick={onClose}>
          <MdArrowBack />
        </IconButton>
        <Typography variant="h2" color="secondary">
          {t("need_assist_text", {
            defaultValue: "Need Assistance Completing Your KYC?",
          })}
        </Typography>
        <Typography variant="h3" color="secondary">
          {t("contact_support_text", {
            defaultValue:
              "Please contact Bayer customer care for quick support and guidance through the process.",
          })}
        </Typography>
        <Button
          component="a"
          href={`tel:+91${KYCConstants?.helpPhoneNumber}`}
          variant="contained"
          size="large"
          startIcon={<MdLocalPhone />}
        >
          {KYCConstants?.helpPhoneNumber}
        </Button>
      </DialogBody>
    </Dialog>
  );
}

export default memo(Help);
